import React from "react";

import TestingCoverageMetadataDimensions from "@main/pages/Release/views/MetricDetails/TestingCoverage/TestingCoverageMetadataDimensions";
import { MetricKeys } from "@main/router/config/routePaths";
import { useParams } from "react-router-dom";

export default function MetricMetadataDimensions() {
  const { metricKey } = useParams<{ metricKey: string }>();

  if (metricKey === MetricKeys.testingCoverage) return <TestingCoverageMetadataDimensions />;

  return <></>;
}
